import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper.ts";

export const modulatorLinkApplianceDto = z.object({
  csLinkId: branded.modulatorLinkCsId,
  hwLinkId: branded.modulatorLinkHwId,
  id: branded.modulatorLinkId,
  localisation: z.string().nullable(),
  appliance: z.object({
    id: branded.applianceId,
    description: z.string(),
    translation: z.string().nullable(),
  }),
});

export type TModulatorLinkApplianceDto = z.infer<typeof modulatorLinkApplianceDto>;
